import Vue from 'vue'

import {
    Search,
    Button,
    Cell,
    Card,
    Divider,
    Image as VanImage,
    ImagePreview,
    Collapse,
    CollapseItem,
    Col,
    Dialog,
    Row,
    Loading,
    Icon,
    PullRefresh,
    List,
    Field,
    Picker,
    Popup,
    Radio,
    RadioGroup,
    Skeleton,
    Pagination,
    Tab,
    Tabs,
    Uploader
} from 'vant'

Vue.use(Button)
Vue.use(Cell)
Vue.use(VanImage)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Col)
Vue.use(Divider)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Loading)
Vue.use(Search)
Vue.use(Icon)
Vue.use(ImagePreview)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Skeleton)
Vue.use(Pagination)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Uploader)
